<template>

        <jt-card-default
          :shouldShowSelectMonth="true"
          :cardSelectType="0"
          @change="onChange"
        >
          <div v-if="isLoading" class="div-loader">
            <div class="spinning-loader rotate"></div>
          </div>
          <jt-line-chart v-else
            centralTitleConst="DASHBOARD_BILLING_AVG_TIME_OUTFLOW"
            :data="historyCollections"
            :xAxisData="columnsLineChart"
            :shouldTranslateXAxisData="true"
            :yAxisIndexNames="['min']"
          />
        </jt-card-default>

</template>

<script>
import JtLineChart from 'src/components/charts/JtLineChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'

@Component({
  name: 'AvgTimeOutflow',
  components: {
    JtCardDefault,
    JtLineChart

  }
})
export default class AvgTimeOutflow extends Vue {
  isLoading = false

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  }

  columnsLineChart = []

  historyCollections = []

  async created () {
    await this.onChange(this.currentDate)
  }

  async onChange (date) {
    this.isLoading = true

    this.doughnutData = await this.getDoughnutData(date)

    this.columnsLineChart = this.doughnutData.map(
      (register) => register.label.toString()
    )

    this.historyCollections = [
      {
        data: this.doughnutData.map((register) => parseInt(register.value)),
        name: this.$gettext('DASHBOARD_BILLING_AVG_TIME_OUTFLOW')
      }]

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'avgTimeOutflow',
        month: date.month,
        year: date.year
      }
    )

    const data = registros.map((registro) => {
      return {
        label: registro.day,
        value: registro.value
      }
    })

    return data
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

</style>
